import React from "react";
import '../App.css'
import traveler1 from "../assets/slider-3-author-1.webp";
import traveler2 from "../assets/slider-3-author-2.webp";
import traveler3 from "../assets/slider-3-author-3.webp";
import traveler4 from "../assets/slider-3-author-4.webp";
import badge from "../assets/gview.webp";
import tripa from "../assets/tripa.webp";
import videoPoster from "../assets/video-poster.jpg";
import videoWebm from "../assets/video.webm";
import videoMp4 from "../assets/video.mp4";

const HeroSection = () => {
  return (
    <div className="relative overflow-hidden">
      {/* Marquee */}
      <div className="bg-gradient-to-r from-[#E91E63] via-[#E91E63] to-[#D32F2F] overflow-hidden shadow h-6 flex items-center relative">
        <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/10 to-transparent"></div>
        <div className="flex whitespace-nowrap animate-marquee">
          {[
            "NATURAL EXPERIENCES",
            "EXPLORE NEW DESTINATIONS",
            "UNFORGETTABLE ADVENTURES",
            "TRAVEL WITH COMFORT",
            "BREATH TAKING VIEWS",
            "SEAMLESS TRAVEL EXPERIENCE",
            "DISCOVER HIDDEN GEMS",
            "LUXURY STAYS & HOTELS",
            "EXCITING CULTURAL EXPERIENCES",
          ].map((text, idx) => (
            <span
              key={idx}
              className="text-white text-sm md:text-base font-bold uppercase mx-8"
            >
              {text}
            </span>
          ))}
        </div>
      </div>

      {/* Hero Section */}
      <section className="relative bg-gradient-to-br from-gray-50 via-white to-amber-50/30 overflow-hidden">
        {/* Decorative BG */}
        <div className="absolute top-20 left-20 w-32 h-32 bg-[#E91E63]/10 rounded-full blur-3xl"></div>
        <div className="absolute bottom-20 right-20 w-40 h-40 bg-orange-400/10 rounded-full blur-3xl"></div>

        <div className="container mx-auto sm:py-12 py-6 px-6 md:px-12 lg:px-16 relative z-10">
          <div className="grid grid-cols-1 lg:grid-cols-2 items-center gap-12">
            {/* Left Content */}
            <div className="space-y-6 order-2 sm:order-1 text-center lg:text-left">
              {/* Profile Row */}
              <div className="flex justify-center lg:justify-start items-center gap-3">
                <div className="flex -space-x-4">
                  {[traveler1, traveler2, traveler3, traveler4].map(
                    (img, idx) => (
                      <img
                        key={idx}
                        src={img}
                        alt={`Traveler ${idx + 1}`}
                        className="h-10 w-10 rounded-full ring-2 ring-white shadow"
                      />
                    )
                  )}
                </div>
                <div className="text-sm text-gray-700">
                  <span className="font-semibold text-gray-800 block">
                    Mehai &amp; 7773+ travelers choice!
                  </span>
                  <span className="text-amber-500">★★★★★</span>
                  <span className="ml-1">(4.9/5)</span>
                </div>
              </div>

              {/* Title */}
              <h1 className="text-4xl md:text-5xl lg:text-6xl font-black text-transparent bg-clip-text bg-gradient-to-r from-gray-900 via-[#E91E63] to-[#D32F2F] leading-tight">
                Best Rajasthan Tour Packages
              </h1>
              <div className="w-24 h-1 bg-gradient-to-r from-[#E91E63] to-[#D32F2F] mx-auto lg:mx-0 rounded-full"></div>

              {/* Description */}
              <p className="text-lg text-gray-700">
                Get the best deal on your Royal Rajasthan Tour Package today{" "}
                <span className="font-semibold text-pink-500">
                  up to 20% OFF
                </span>
                . Make your Rajasthan trip memorable. Call us now to know more.
              </p>

              <h3 className="text-lg font-semibold text-gray-800">
                Our Lifetime Memories
              </h3>
              <div className="sm:h-28 h-24">
                <img src={tripa} alt="Example" className="h-full" />
              </div>

              {/* Button Section */}
              <div className="flex flex-col items-center lg:items-start gap-4">
                <div className="flex items-center gap-2 bg-[#E0F7FA] border border-[#00838F]/20 rounded-full px-4 py-2 shadow-sm">
                  <div className="w-3 h-3 bg-[#00838F] rounded-full animate-pulse"></div>
                  <span className="text-sm text-[#00838F] font-bold">
                    15 people are checking out right now
                  </span>
                </div>
                <button className="group bg-gradient-to-r from-[#E91E63] to-[#D32F2F] text-white px-3 py-2 rounded-2xl font-bold text-lg shadow-lg hover:shadow-2xl transition duration-300 flex items-center gap-2">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className="w-4 h-4"
                  >
                    <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.86 19.86 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6A19.86 19.86 0 0 1 2.11 4.18 2 2 0 0 1 4.1 2h3a2 2 0 0 1 2 1.72c.12 1.05.37 2.07.72 3.05a2 2 0 0 1-.45 2.11l-1.27 1.27a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45c.98.35 2 .6 3.05.72A2 2 0 0 1 22 16.92z"></path>
                  </svg>
                  Plan Your Dream Trip - Get Free Quote Now
                </button>
                <p className="text-sm text-gray-600">
                  💎 Premium packages with exclusive deals
                </p>
              </div>
            </div>

            {/* Right Video */}
            <div className="relative order-1 sm:order-2 w-full">
              <div className="relative rounded-3xl overflow-hidden">
                <video
                  poster={videoPoster}
                  autoPlay
                  loop
                  playsInline
                  muted
                  preload="metadata"
                  className="w-full h-full rounded-3xl"
                >
                  <source src={videoWebm} type="video/webm" />
                  <source src={videoMp4} type="video/mp4" />
                </video>
              </div>

              {/* Stats */}
              <div className="absolute -bottom-8 left-1/2 -translate-x-1/2 flex gap-4 z-30">
                <div className="bg-white rounded-xl px-4 py-2 text-center shadow border border-gray-100">
                  <div className="text-[#E91E63] text-lg font-bold">50K+</div>
                  <div className="text-sm text-gray-600">Happy Travelers</div>
                </div>
                <div className="bg-white rounded-xl px-4 py-2 text-center shadow border border-gray-100">
                  <div className="text-[#E91E63] text-lg font-bold">115+</div>
                  <div className="text-sm text-gray-600">Destinations</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default HeroSection;
